const testimonials = [
  {
    name: "Patricia L.",
    location: "Historic District, Savannah, GA",
    rating: 5,
    text: "We booked a cruise to the Bahamas that left from Savannah in 5 days and realized my husband's passport was expired. Fast Passport Center got him an expedited passport in 3 days. They were incredible — answered my panicked calls at 9 PM and walked us through every single step.",
    service: "Emergency Passport",
  },
  {
    name: "James M.",
    location: "Pooler, GA",
    rating: 5,
    text: "My daughter had a study abroad program in Spain and her passport was about to expire within the 6-month window. We started online from Pooler, shipped from the UPS Store, and had the renewal back in 6 days. Completely stress-free process.",
    service: "Passport Renewal",
  },
  {
    name: "Denise W.",
    location: "Richmond Hill, GA",
    rating: 5,
    text: "My two kids needed passports for a family trip to Mexico. I had no idea what forms were needed or which clerk to visit in the Savannah area. Fast Passport Center sent us a perfect checklist, told us exactly which post office to go to, and handled the expedited processing. Got them in 9 days.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function SavannahTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Savannah Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Savannah, Pooler, Richmond Hill, and coastal Georgia who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}